import React from "react";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import Badge from "@mui/material/Badge";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../../users/providers/UserProvider";
import ROUTES from "../../../../routes/routesModel";
import MoreButton from "../right-navigation/MoreButton";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import BarChartIcon from "@mui/icons-material/BarChart";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState } from "react";
import useHandleUser from "../../../../users/hooks/useHandleUser";
import { useCart } from "../../../../provider/CartProvider";
import SettingsIcon from "@mui/icons-material/Settings";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PersonIcon from "@mui/icons-material/Person";

const LeftNavBar = () => {
  const { user } = useUser();
  const navigate = useNavigate();
  const { cart, openCartDrawer } = useCart();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [showAdminMenu, setShowAdminMenu] = useState(false);
  const open = Boolean(anchorEl);
  const { handleLogout } = useHandleUser();

  const handleLogoClick = () => {
    navigate(ROUTES.ROOT);
  };

  const handleFavoriteClick = () => {
    navigate(ROUTES.GUEST_FAVORITES);
  };

  const handleAccountClick = (event: React.MouseEvent<HTMLElement>) => {
    if (user) {
      setAnchorEl(event.currentTarget);
    } else {
      navigate("/login");
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setShowAdminMenu(false);
  };

  const handleEditUser = () => {
    if (user) {
      navigate(`${ROUTES.EDIT_ACCOUNT}/${user._id}`);
      handleMenuClose();
    }
  };

  const handleAdminMenuClick = () => {
    setShowAdminMenu(true);
  };

  const handleBackToMainMenu = () => {
    setShowAdminMenu(false);
  };

  const handleAdminItemClick = (route: string) => {
    navigate(route);
    handleMenuClose();
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "relative",
      }}
    >
      {/* Desktop: Favorites on left */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          zIndex: 2,
          flex: 1,
          justifyContent: "flex-start",
        }}
      >
        <Tooltip title="מועדפים">
          <IconButton sx={{ color: "#113355" }} onClick={handleFavoriteClick}>
            <FavoriteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>

      {/* Centered Logo - absolutely centered and fully clickable */}
      <Box
        sx={{
          position: "absolute",
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          component="img"
          onClick={handleLogoClick}
          sx={{
            mt: 1,
            cursor: "pointer",
            height: 90,
          }}
          alt="לב הארץ לוגו"
          src="/assets/images/newLogo.png"
        />
      </Box>

      {/* Mobile: Hamburger (More) menu on left */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          alignItems: "center",
          gap: 1,
          zIndex: 2,
          flex: 1,
          justifyContent: "flex-start",
        }}
      >
        <MoreButton />
      </Box>

      {/* Mobile: Account, Favorite, Cart on right */}
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          alignItems: "center",
          gap: 1,
          zIndex: 2,
          flex: 1,
          justifyContent: "flex-end",
        }}
      >
        {user && (
          <Tooltip title="החשבון שלי">
            <IconButton sx={{ color: "#113355" }} onClick={handleAccountClick}>
              <AccountCircleIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {user && (
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MenuItem
              onClick={() => {
                handleLogout();
                handleMenuClose();
              }}
            >
              יציאה
            </MenuItem>
          </Menu>
        )}
        <Tooltip title="מועדפים">
          <IconButton sx={{ color: "#113355" }} onClick={handleFavoriteClick}>
            <FavoriteIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Tooltip title="עגלת קניות">
          <IconButton sx={{ color: "#113355" }} onClick={openCartDrawer}>
            <Badge badgeContent={cart.length} color="error" overlap="circular">
              <ShoppingCartIcon fontSize="small" />
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>

      {/* Desktop: Cart and Account on LEFT */}
      <Box
        sx={{
          display: { xs: "none", md: "flex" },
          alignItems: "center",
          zIndex: 2,
          flex: 1,
          justifyContent: "flex-end",
          gap: 1,
        }}
      >
        <Tooltip title="עגלת קניות">
          <IconButton sx={{ color: "#113355" }} onClick={openCartDrawer}>
            <Badge badgeContent={cart.length} color="error">
              <ShoppingCartIcon fontSize="small" />
            </Badge>
          </IconButton>
        </Tooltip>

        {user && (
          <Tooltip title="החשבון שלי">
            <IconButton sx={{ color: "#113355" }} onClick={handleAccountClick}>
              <AccountCircleIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
        {user && (
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMenuClose}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            transformOrigin={{ vertical: "top", horizontal: "left" }}
          >
            <MenuItem
              onClick={() => {
                handleLogout();
                handleMenuClose();
              }}
            >
              יציאה
            </MenuItem>
          </Menu>
        )}
      </Box>
    </Box>
  );
};

export default LeftNavBar;
